// Identifies the column that contains the action buttons
export const ACTION_COLUMN_ID = "actions";
// Identifies the column that contains the row numbers
export const ROW_NUMBER_COLUMN_ID = "rowNumber";
